import { ReactNode } from "react";
import { tabProps } from "./helper";

interface TabPanelProps {
    children?: ReactNode;
    name: string;
    currentTab: string;
}

/**
 * component to represent a tab-panel in the personal profile page,
 * wired with accessibility props etc.
 */
export function TabPanel({ children, currentTab, name }: TabPanelProps) {
    const { id: tabId, "aria-controls": panelId } = tabProps(name);

    return (
        <div role="tabpanel" hidden={currentTab !== name} id={panelId} aria-labelledby={tabId}>
            {children}
        </div>
    );
}
